var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{ref:"el",staticClass:"mdui-select",domProps:{"value":_vm.value},on:{"change":function($event){_vm.$emit('change', parseInt($event.target.value))}}},_vm._l((_vm.options),function(opt){return _c('option',{key:`opt-${opt}`,domProps:{"value":opt}},[_vm._v(_vm._s(_vm.display ? _vm.display(opt) : opt))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }